import React, { useContext, useState } from 'react'
import { Box } from '@mui/material'
import { Button, Card, makeStyles, Typography } from '@material-ui/core'
import CustomTextField from 'components/Form/CustomTextField'
import { Form, Formik } from 'formik'
import { moderatorLoginSchema } from 'schemas/polling-1'
import { useDispatch } from 'react-redux'
import { fetchEventViaPINCode } from 'store/event'
import { useHistory } from 'react-router-dom'
import { EventContext, SessionContext } from 'context'
import { fetchSessionViaPINCode } from 'store/session'
import { toast } from 'react-toastify'

const ModeratorsLogin = () => {
  const { event, login } = useContext(EventContext)
  const { session, loginSession } = useContext(SessionContext)
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const initialValues = {
    pinCode: ''
  }
  const onSubmit = async (values) => {
    setLoading(true)
    const event = await dispatch(fetchEventViaPINCode(values.pinCode))
    const session = await dispatch(fetchSessionViaPINCode(values.pinCode))
    event && login(event)
    session && loginSession(session)

    if (!event && !session) {
      toast.error('No event/session found against this PIN code.')
    }
    setLoading(false)
  }

  if ((event && event?.id) || (session && session?.id)) {
    history.push('/dashboard/polls')
  }

  return (
    <Box className={classes.mainBox}>
      <Card className={classes.card} elevation={0}>
        <Typography className={classes.header} variant="h6">
          MeetSymple
        </Typography>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={moderatorLoginSchema}
          onSubmit={onSubmit}>
          <Form className={classes.form}>
            <CustomTextField
              label="PIN Code"
              placeholder="Enter PIN code here"
              name="pinCode"
              type="text"
            />
            <Button
              className={classes.loginBtn}
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={loading}>
              Start
            </Button>
          </Form>
        </Formik>
      </Card>
    </Box>
  )
}

export default ModeratorsLogin

const useStyles = makeStyles({
  mainBox: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#7f7f7f'
  },
  card: {
    minWidth: '400px',
    borderRadius: '16px',
    padding: '15px 40px 30px 40px'
  },
  header: {
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: 14
  },
  form: {
    marginTop: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  loginBtn: {
    fontWeight: 'bold',
    textTransform: 'none',
    width: '100%'
  }
})
